import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { ChannelService } from './services/channel.service';
import { ScreeningService } from './services/screening.service';
import { AuthService } from './services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { ApplicantDataService } from './services/applicant-data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent  implements AfterViewInit{
  constructor(public location : Router,public channels : ChannelService, public auth: AuthService, public toast : ToastrService, public appData : ApplicantDataService){
  }

  ngAfterViewInit(): void {
    // this.appData.inviteFetched.subscribe(e =>{
    //   this.channels.start();
    // })
  }

  throwToast(){
this.toast.info('test message')
  }

  // continue() : void {
  //   console.log('navigating')
  //   this.location.navigateByUrl('/screen')
  // }
}
